export class CardinalityError extends Error {
    constructor(message, field = 'minimum') {
        super(message);
        this.name = 'CardinalityError';
        this.field = field;
    }
}

function integer(value, field, minimum) {
    const label = field === 'minimum' ? 'Le minimum' : 'Le maximum';
    if (!/^\d+$/.test(value)) {
        throw new CardinalityError(`${label} doit être un entier ${minimum ? 'positif' : 'supérieur ou égal à 0'}.`, field);
    }
    const result = Number(value);
    if (!Number.isSafeInteger(result)) {
        throw new CardinalityError(`${label} ne doit pas dépasser ${Number.MAX_SAFE_INTEGER}.`, field);
    }
    if (result < minimum) {
        throw new CardinalityError(`${label} doit être supérieur ou égal à ${minimum}.`, field);
    }
    return result;
}

function parseBounds(lower, upper) {
    const minimum = integer(lower, 'minimum', 0);
    const maximum = /^n$/i.test(upper) ? null : integer(upper, 'maximum', 1);
    if (maximum !== null && maximum < minimum) {
        throw new CardinalityError('Le maximum doit être supérieur ou égal au minimum.', 'maximum');
    }
    return { minimum, maximum, value: `${minimum},${maximum ?? 'n'}` };
}

/** The same grammar is used by the editor, imports and local restoration. */
export function parseCardinality(value) {
    if (typeof value !== 'string' || value.length > 160 || value.split(',').length !== 2) {
        throw new CardinalityError('Indiquez un minimum et un maximum séparés par une virgule.');
    }
    return parseBounds(...value.split(',').map(part => part.trim()));
}

export function cardinalityFromInputs({ minimum, maximum, unlimited }) {
    return parseBounds(minimum.trim(), unlimited ? 'n' : maximum.trim());
}
